module.exports = __webpack_public_path__ + "img/3rd.3cb26bd4.png";